import React from 'react';
import { UserPlus, FileCheck, TrendingUp } from 'lucide-react';

const SCHRITTE = [
  {
    nummer: '1',
    icon: UserPlus,
    title: 'Registrieren',
    text: 'Schnelle Anmeldung mit E-Mail. Abo ab 29,99€ inkl. MwSt./Monat.'
  },
  {
    nummer: '2',
    icon: FileCheck,
    title: 'Onboarding',
    text: 'Profil vervollständigen, Vertragsbedingungen bestätigen.'
  },
  {
    nummer: '3',
    icon: TrendingUp,
    title: 'Fälle erfassen',
    text: 'Digitale Fall-Erfassung im Portal, Provision nach Regulierung.'
  }
];

export const WieEsFunktioniert = () => {
  return (
    <section className="py-28 lg:py-36 bg-white">
      <div className="max-w-6xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Ablauf
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            Wie es funktioniert
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {SCHRITTE.map((schritt, index) => {
            const Icon = schritt.icon;
            return (
              <div key={index} className="bg-gradient-to-br from-gray-50 to-white border border-gray-100 rounded-3xl p-8 hover:border-brand-green/30 hover:shadow-xl transition-all duration-300 text-center">
                <div className="flex items-center justify-center gap-3 mb-6">
                  <div className="w-12 h-12 bg-brand-green text-white rounded-xl flex items-center justify-center font-bold text-lg">
                    {schritt.nummer}
                  </div>
                  <div className="w-12 h-12 bg-brand-green/10 rounded-xl flex items-center justify-center border border-brand-green/15">
                    <Icon className="w-6 h-6 text-brand-green" />
                  </div>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 tracking-tight">{schritt.title}</h3>
                <p className="text-gray-600 leading-relaxed text-[15px]">{schritt.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};